import { APICfg } from 'services/api/api'
import {
  VirtualExperienceSection,
  VirtualExperienceSectionToAPI,
} from 'services/api/entities/catalog/sections/experienceSection'
import { productSectionParse } from '../utils'

const apiCfg: APICfg = {
  endpoint: 'virtualexperiencessections',
  parse: productSectionParse,
  write: async (
    req: VirtualExperienceSection
  ): Promise<VirtualExperienceSectionToAPI> => req,
}

export default apiCfg
